var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0802 0.452422C11.2715 0.315827 11.5283 0.315827 11.7196 0.452422L21.9196 7.73814C22.0641 7.84138 22.1499 8.00807 22.1499 8.18569V17.9C22.1499 18.2037 21.9037 18.45 21.5999 18.45C21.2961 18.45 21.0499 18.2037 21.0499 17.9V8.46873L11.3999 1.57587L1.7499 8.46873V20.75H9.8999C10.2037 20.75 10.4499 20.9962 10.4499 21.3C10.4499 21.6037 10.2037 21.85 9.8999 21.85H1.1999C0.896146 21.85 0.649902 21.6037 0.649902 21.3V8.18569C0.649902 8.00807 0.735683 7.84138 0.880221 7.73814L11.0802 0.452422Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1999 17.45C13.5037 17.45 13.7499 17.6963 13.7499 18V22.85H22.1999C22.5037 22.85 22.7499 23.0963 22.7499 23.4C22.7499 23.7038 22.5037 23.95 22.1999 23.95H13.1999C12.8961 23.95 12.6499 23.7038 12.6499 23.4V18C12.6499 17.6963 12.8961 17.45 13.1999 17.45Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 11.6111C11.226 11.3963 11.5742 11.3963 11.789 11.6111L15.389 15.2111C15.6038 15.4259 15.6038 15.7741 15.389 15.9889C15.1742 16.2037 14.826 16.2037 14.6112 15.9889L11.0112 12.3889C10.7964 12.1741 10.7964 11.8259 11.0112 11.6111Z",
    fill: "#383634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 15.9889C10.7964 15.7741 10.7964 15.4259 11.0112 15.2111L14.6112 11.6111C14.826 11.3963 15.1742 11.3963 15.389 11.6111C15.6038 11.8259 15.6038 12.1741 15.389 12.3889L11.789 15.9889C11.5742 16.2037 11.226 16.2037 11.0112 15.9889Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovalIcon);
export default __webpack_public_path__ + "static/media/removal_icon.c49c568782bb9201ebe05a572a677e9e.svg";
export { ForwardRef as ReactComponent };